import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  packages = {
    ongoing: [],
    completed: []
  };
  mainData = {
    ongoing: [],
    completed: []
  };

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService) { }

  ngOnInit() {

   

  }

  userProfile(){
    this.router.navigateByUrl(`userprofile`);
  }
  
  enrollment(){   
    this.router.navigateByUrl(`enrollment`);
  }

  segmentChanged(completed){
    

  }
  assessment(){
    this.router.navigateByUrl(`assessment`);
  }
  dashboard(){    
    this.router.navigateByUrl(`dashboard`);
  }
  assignment(){
    this.router.navigateByUrl(`assignment`);
  }
  notice(){
    this.router.navigateByUrl(`notice`); 
  }
  enquiry(){
    this.router.navigateByUrl(`enquiry`);
  }
  content(){
    this.router.navigateByUrl(`content`);
  }
  classes(){
    this.router.navigateByUrl(`courses`);
  }
  calender(){
    this.router.navigateByUrl(`calender`);
  }
  requirements(){
    this.router.navigateByUrl(`requirements`);
  }

}
